import { render, staticRenderFns } from "./PostSrc.vue?vue&type=template&id=752dd814&scoped=true&lang=pug&"
import script from "./PostSrc.vue?vue&type=script&lang=js&"
export * from "./PostSrc.vue?vue&type=script&lang=js&"
import style0 from "./PostSrc.vue?vue&type=style&index=0&id=752dd814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dd814",
  null
  
)

export default component.exports